import { useTranslation } from 'react-i18next'
import AlertComponent from '../Generics/Alert'
import SociogramSurveysList from '../Generics/CollapsePanel/SociogramSurveysList'
import CreateSociogramModal from './CreateSociogramModal'
import { useContext } from 'react'
import { CoursesContext } from '@BUP/contexts/CoursesContext'
import SociogramSwitcher from './sociogram-switcher'
import styles from './sociogram-content-ece.module.scss'

const SociogramContentEce = ({ currentSociogram, events, selectedEvent, sociogramState, disabled }) => {
  const i18n = useTranslation()
  const { courses } = useContext(CoursesContext)
  const selectedSociogramId = selectedEvent?.activityId

  if (courses.length === 0) {
    return (
      <div className={styles.alert_wrapper}>
        <AlertComponent message={i18n.t('pages.data.sociogram.activeSociogramEce.noCoursesText')} type='info' />
      </div>
    )
  }

  if (!currentSociogram || events.length === 0) {
    return (
      <CreateSociogramModal />
    )
  }

  if (!selectedSociogramId && sociogramState === 1) {
    return (
      <>
        <SociogramSwitcher
          sociogramState={sociogramState}
          events={events}
          disabled={disabled}
        />
        <CreateSociogramModal disabled={disabled} />
      </>
    )
  }

  return (
    <>
      <SociogramSwitcher
        sociogramState={sociogramState}
        events={events}
        disabled={disabled}
      />
      <SociogramSurveysList
        events={events}
        selectedEvent={selectedEvent}
      />
    </>
  )
}

export default SociogramContentEce
